<article class="card" [attr.is_active]="isActive" (click)="onItemClick()">
  <div class="card-body d-flex flex-row p-2">
    <div class="w-100 text-break">
      <h3 [attr.data-test-id]="'result-user-title-' + index">
        {{ data.user.displayedName }}
        <h5 [attr.data-test-id]="'result-user-status-' + index" class="text-muted">
          {{ getStatusMark | translate }}
        </h5>
      </h3>
      <h5 *ngIf="data.user?.role" [attr.data-test-id]="'result-user-role-' + index">
        {{ data.user.role | translate }}
      </h5>
      <h6 *ngIf="data?.specialization?.length" [attr.data-test-id]="'result-user-specialization-' + index">
        {{ data.specialization | formatCategories }}
      </h6>
      <h6 class="mb-0" [attr.data-test-id]="'result-user-location-' + index" [innerHtml]="data.displayedLocation"></h6>
    </div>
    <div *ngIf="isLoggedIn" class="align-self-center ms-2">
      <a
        class="btn btn-primary"
        [attr.data-test-id]="'result-user-visit-button-' + index"
        [ngClass]="{ disabled: deactivated && !isAdminSession }"
        [routerLink]="data.routerLink"
        target="_blank"
      >
        {{ 'BTN_VISIT' | translate }}
      </a>
    </div>
  </div>
</article>
